export default __webpack_public_path__ + "static/media/camera.7885b20a.svg";